import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsFor() {
  const isFor = ['Hombres latinos en USA de 30 a 50 años con poco tiempo libre.', 'Tipos que sienten que su metabolismo se "frenó" después de los 35.', 'Padres de familia que quieren tener energía para jugar con sus hijos sin quedarse sin aire.', 'Profesionales que necesitan verse y sentirse con autoridad en su ropa de trabajo.'];
  const notFor = ['Gente que busca "pastillas mágicas" sin cambiar un solo hábito.', 'Fisicoculturistas que quieren marcar abdominales para una competencia.', 'Personas que no están dispuestas a dejar las harinas por tan solo 14 días.'];
  return <section className="bg-dark-bg text-white py-20 px-4 md:px-8" data-id="element-139">
      <div className="max-w-6xl mx-auto" data-id="element-140">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-141">
          {/* IS FOR */}
          <div className="bg-dark-surface p-8 rounded-xl border-t-4 border-brand-orange shadow-lg" data-id="element-142">
            <h3 className="font-oswald text-2xl md:text-3xl font-bold mb-8 uppercase text-center" data-id="element-143">
              Esto <span className="text-brand-orange" data-id="element-144">SÍ</span> es para vos si:
            </h3>
            <ul className="space-y-6" data-id="element-145">
              {isFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-146">
                  <CheckCircle2 className="w-6 h-6 text-brand-orange mr-4 flex-shrink-0 mt-1" data-id="element-147" />
                  <span className="font-inter text-gray-300 text-lg" data-id="element-148">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* NOT FOR */}
          <div className="bg-dark-surface p-8 rounded-xl border-t-4 border-red-600 shadow-lg" data-id="element-149">
            <h3 className="font-oswald text-2xl md:text-3xl font-bold mb-8 uppercase text-center" data-id="element-150">
              Esto <span className="text-red-500" data-id="element-151">NO</span> es para vos si:
            </h3>
            <ul className="space-y-6" data-id="element-152">
              {notFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-153">
                  <XCircle className="w-6 h-6 text-red-500 mr-4 flex-shrink-0 mt-1" data-id="element-154" />
                  <span className="font-inter text-gray-300 text-lg" data-id="element-155">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}